import React, { useRef, useState, useEffect, useCallback, Component } from 'react';
import Triangles from './Triangles.js';
import Tone from 'tone';
import {LOW_SAMPLE_RATE} from 'constants/sample-rates.js';
import StickyLogo from './StickyLogo.js';
import Contact from './Contact.js';
import ethereum from 'decentralized/ethereum.js';
import accounts from 'accounts/Accounts.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import GettingStarted from './GettingStarted.js';
import LandingAbout from './LandingAbout.js';
import LandingAbout2 from './LandingAbout2.js';
import LandingNavigator from './LandingNavigator.js';
import Documentation from 'components/documentation/Documentation.js';
import UniversalNavigator from 'components/UniversalNavigator.js';
import '../../Landing.scss';
import {
    ABOUT,
    GETTING_STARTED,
    CONTACT,
    HELP
} from './constants.js';
var AudioContext = window.AudioContext || window.webkitAudioContext;

const LandingPage = (props) => {
    let [option, setOption] = useState(props.location.pathname === '/documentation' ? HELP : ABOUT);
    let ref = useRef(undefined);
    let [part, setPart] = useState(0);
    let [toggled, setToggled] = useState(false);
    let [contextLoaded, setContextLoaded] = useState(false);

    ethereum.store = props.store;
    accounts.setStore(props.store);
    accounts.setEthereum(ethereum);

    useEffect(() => {
        window.landing = true;
        accounts.checkLogin();
        Tone.setContext(new AudioContext(
            {
                // latencyHint: "playback",
                sampleRate: LOW_SAMPLE_RATE
            }));
        setContextLoaded(true);
    }, []);

    let className = option === HELP ? "landing-page showing-doc" : "landing-page";
    if (part !== 0 && option !== HELP) {
        className += " part part-" + part;
    }
    return (
        <div ref={ref} className={className}>
          <Triangles/>
          <div className="content">
            <div className="create-explore-learn">
              <a href="/create">create</a>
              <a href="/explore">explore</a>
              <a className={option === HELP ? "selected" : ""} onClick={() => setOption(HELP)} >learn</a>
            </div>
            <div className="logos">
              <img onClick={() => setOption(ABOUT)} className="circle-logo" src="/logo.svg"/>
              <img onClick={() => setOption(ABOUT)} className="text-logo" src="/zequencer-name-stretched.svg"/>
            </div>
            <ConditionedComponent condition={option === ABOUT}>
              <LandingAbout2
                setPart={setPart}
                toggled={toggled}
                contextLoaded={contextLoaded}
                store={props.store}>
              <div className="contact-us" onClick={() => setOption(CONTACT)} >Contact Us</div>
              </LandingAbout2>
            </ConditionedComponent>
            <StickyLogo url="/darkside-logo.svg" setToggled={setToggled} toggled={toggled}/>
            <ConditionedComponent condition={option === GETTING_STARTED}>
              <GettingStarted/>
              <a onClick={() => setOption(CONTACT)} >Contact Us</a>
            </ConditionedComponent>
            <ConditionedComponent condition={option === HELP}>
              <Documentation store={props.store}/>
            </ConditionedComponent>
            <ConditionedComponent condition={option === CONTACT}>
              <Contact store={props.store}/>
              <a onClick={() => setOption(ABOUT)} >Take Me Back</a>
            </ConditionedComponent>
          </div>
        </div>
    );
}

export default LandingPage;
